import styled from 'styled-components';

import { colors } from '@alixpartners/ui-components';
import noDataImage from 'assets/images/no-data.png';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
`;

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  margin-top: 22px;
  background-image: url(${noDataImage});
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 384px;
  min-width: 384px;
`;

export const TextContainer = styled.div`
  max-width: 554px;
  margin-top: -38px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  color: ${colors.grey8};
  margin-bottom: 24px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.3px;
  font-size: 33px;
  line-height: 41px;
  text-align: center;
  letter-spacing: 0.3px;
`;

export const Text = styled.div`
  color: ${colors.grey5};
  letter-spacing: 0;
  line-height: 27px;
  text-align: center;
  width: 278px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 0;
  justify-content: center;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
